import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref } from "vue";
import { AddApiKeyModel, ApiKeyModel, IApiKeyService } from '@truckdown/accounts';
import validationError from "../../Validation/Error/Error.vue";
import { showMessage } from '../../Utilities/Utilities';

interface IData {
    isLoading: Ref<boolean>,
    add: Ref<AddApiKeyModel>,
    apiKey: Ref<ApiKeyModel>
};

const getInitialData = function (props: any) {
    var add = {
        accountId: props.accountId,
        name: "",
        redirectUrl: ""
    } as AddApiKeyModel;

    return {
        isLoading: ref<boolean>(false),
        add: ref<AddApiKeyModel>(add),
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        cancelClick: function (): void {
            ctx.emit(cancelEventName);
        },
        saveClick: async function (): Promise<void> {
            if (!data.isLoading.value) {
                data.isLoading.value = true;

                try {
                    let apiKeyService = await context.getService<IApiKeyService>('IApiKeyService');
                    var response = await apiKeyService.add(data.add.value);
                    if (!response || !response.ok) {
                        console.log("Error creating API Key: " + response.message);
                        showMessage("Error creating API Key.", "danger", true, true);
                    } else {
                        showMessage("API Key was successfully created.", "success", true, true);
                        ctx.emit(updateEventName, response.data);
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    data.isLoading.value = false;
                }
            }
        }
    }
}

const updateEventName = 'update';
const cancelEventName = 'cancel';

export default defineComponent({
    props: {
        accountId: String
    },
    components: {
        'error': validationError
    },
    emits: [updateEventName, cancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});